<template>
  <div class="container-fluid">
    <div class="row flex-row">
      <div class="col-xl-3">
        <div class="widget has-shadow">
          <div class="widget-body">
            <h3 class="text-center mt-3 mb-1">{{ bot.username || 'ربات جدید' }}</h3>
            <p class="text-center">{{ bot.isGirl ? 'دخترونه' : 'پسرونه' }}</p>
            <p class="text-center text-muted">سطح پایه: {{ bot.level || 1 }}</p>
            <div class="em-separator separator-dashed"></div>
          </div>
        </div>
      </div>

      <div class="col-xl-9">
        <div class="widget has-shadow">
          <div class="widget-header bordered no-actions d-flex align-items-center">
            <h4>{{ isEdit ? 'ویرایش ربات' : 'ربات جدید' }}</h4>
          </div>
          <div class="widget-body">
            <form class="form-horizontal" v-on:submit.prevent="save">
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">نام کاربری</label>
                <div class="col-lg-6">
                  <input type="text" class="form-control" required v-model="bot.username" />
                </div>
              </div>

              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">جنسیت</label>
                <div class="col-lg-6">
                  <select class="form-control" v-model="bot.isGirl">
                    <option :value="false">پسرونه</option>
                    <option :value="true">دخترونه</option>
                  </select>
                </div>
              </div>

              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">سطح پایه</label>
                <div class="col-lg-6">
                  <input type="number" min="1" class="form-control" v-model.number="bot.level" />
                </div>
              </div>

              <fake-bot-asset-section
                title="آواتارها"
                :items="bot.avatars"
                :selected-id="selectedAvatarId"
                :options="filteredAvatars"
                selected-label="آواتار انتخاب‌شده"
                :label-for="avatarLabel"
                :show-gender="true"
                :gender-for="avatarGender"
                @add="addAvatar"
                @remove="removeAvatar"
                @select="setSelectedAvatar"
              />

              <fake-bot-asset-section
                title="مهره‌ها"
                :items="bot.skins"
                :selected-id="selectedSkinId"
                :options="availableSkins"
                selected-label="مهره انتخاب‌شده"
                :label-for="skinLabel"
                @add="addSkin"
                @remove="removeSkin"
                @select="setSelectedSkin"
              />

              <fake-bot-asset-section
                title="ترکیب‌ها"
                :items="bot.formations"
                :selected-id="selectedFormationId"
                :options="availableFormations"
                selected-label="ترکیب انتخاب‌شده"
                :label-for="formationLabel"
                @add="addFormation"
                @remove="removeFormation"
                @select="setSelectedFormation"
              />

              <fake-bot-asset-section
                title="کفش‌ها"
                :items="bot.boots"
                :selected-id="selectedBootId"
                :options="availableBoots"
                selected-label="کفش انتخاب‌شده"
                :label-for="bootLabel"
                @add="addBoot"
                @remove="removeBoot"
                @select="setSelectedBoot"
              />

              <div class="em-separator separator-dashed"></div>
              <div class="text-right">
                <button type="submit" class="btn btn-gradient-01" :disabled="saving">ذخیره تغییرات</button>
                <router-link class="btn btn-shadow" to="/dashboard/fake">بازگشت</router-link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const shopService = require('../../../../services/shop');
const bootService = require('../../../../services/boot');
const FakeUsersService = require('../../../../services/fakeUsersService');

const emptyBot = () => ({
  username: '',
  isGirl: false,
  level: 1,
  avatars: [],
  skins: [],
  formations: [],
  boots: [],
});

export default {
  name: 'fakeBotDetail',
  components: {
    FakeBotAssetSection: () => import('./FakeBotAssetSection.vue'),
  },
  data() {
    return {
      bot: emptyBot(),
      botId: null,
      saving: false,
      allAvatars: [],
      allSkins: [],
      allFormations: [],
      allBoots: [],
    };
  },
  computed: {
    isEdit() {
      return Boolean(this.botId);
    },
    selectedAvatarId() {
      return this.itemId(this.bot.selectedAvatar);
    },
    selectedSkinId() {
      return this.itemId(this.bot.selectedSkin);
    },
    selectedFormationId() {
      return this.itemId(this.bot.selectedFormation);
    },
    selectedBootId() {
      return this.itemId(this.bot.selectedBoot);
    },
    filteredAvatars() {
      const owned = new Set((this.bot.avatars || []).map(this.itemId));
      return this.allAvatars.filter(a => {
        if (owned.has(a._id)) return false;
        return this.bot.isGirl ? a.isGirl : !a.isGirl;
      });
    },
    availableSkins() {
      return this.filterAvailable(this.allSkins, this.bot.skins);
    },
    availableFormations() {
      return this.filterAvailable(this.allFormations, this.bot.formations);
    },
    availableBoots() {
      return this.filterAvailable(this.allBoots, this.bot.boots);
    },
  },
  created() {
    this.loadAssets();
    if (this.$route.query.id) {
      this.botId = this.$route.query.id;
      this.loadBot(this.botId);
    }
  },
  methods: {
    itemId(item) {
      if (!item) return '';
      return item._id ? item._id : item;
    },
    filterAvailable(allItems, ownedItems) {
      const owned = new Set((ownedItems || []).map(this.itemId));
      return allItems.filter(item => !owned.has(item._id));
    },
    avatarGender(item) {
      return item.isGirl ? 'دخترونه' : 'پسرونه';
    },
    avatarLabel(item) {
      const name = item.avatarName || item.name || item._id;
      return `${name} (${this.avatarGender(item)})`;
    },
    skinLabel(item) {
      return `${item.skinName || ''} ${item.skinCat || ''}`.trim() || item._id;
    },
    formationLabel(item) {
      return item.formationName || item._id;
    },
    bootLabel(item) {
      return item.BootName || item._id;
    },
    findById(list, id) {
      return list.find(item => this.itemId(item) === id);
    },
    addToList(listKey, catalog, id) {
      const item = this.findById(catalog, id) || id;
      if (!this.bot[listKey].some(entry => this.itemId(entry) === id)) {
        this.bot[listKey].push(item);
      }
    },
    removeFromList(listKey, selectedKey, id) {
      this.bot[listKey] = this.bot[listKey].filter(entry => this.itemId(entry) !== id);
      if (this.itemId(this.bot[selectedKey]) === id) this.$set(this.bot, selectedKey, '');
    },
    addAvatar(id) {
      this.addToList('avatars', this.allAvatars, id);
    },
    removeAvatar(id) {
      this.removeFromList('avatars', 'selectedAvatar', id);
    },
    setSelectedAvatar(id) {
      this.$set(this.bot, 'selectedAvatar', id || '');
    },
    addSkin(id) {
      this.addToList('skins', this.allSkins, id);
    },
    removeSkin(id) {
      this.removeFromList('skins', 'selectedSkin', id);
    },
    setSelectedSkin(id) {
      this.$set(this.bot, 'selectedSkin', id || '');
    },
    addFormation(id) {
      this.addToList('formations', this.allFormations, id);
    },
    removeFormation(id) {
      this.removeFromList('formations', 'selectedFormation', id);
    },
    setSelectedFormation(id) {
      this.$set(this.bot, 'selectedFormation', id || '');
    },
    addBoot(id) {
      this.addToList('boots', this.allBoots, id);
    },
    removeBoot(id) {
      this.removeFromList('boots', 'selectedBoot', id);
    },
    setSelectedBoot(id) {
      this.$set(this.bot, 'selectedBoot', id || '');
    },
    buildPayload() {
      return {
        ...this.bot,
        avatars: (this.bot.avatars || []).map(this.itemId),
        skins: (this.bot.skins || []).map(this.itemId),
        formations: (this.bot.formations || []).map(this.itemId),
        boots: (this.bot.boots || []).map(this.itemId),
        selectedAvatar: this.itemId(this.bot.selectedAvatar) || undefined,
        selectedSkin: this.itemId(this.bot.selectedSkin) || undefined,
        selectedFormation: this.itemId(this.bot.selectedFormation) || undefined,
        selectedBoot: this.itemId(this.bot.selectedBoot) || undefined,
      };
    },
    async loadAssets() {
      try {
        const [avatars, skins, formations, boots] = await Promise.all([
          shopService.avatars(),
          shopService.skins(),
          shopService.formations(),
          bootService.allBoots({}),
        ]);
        this.allAvatars = avatars.filter(a => !a.isDefault);
        this.allSkins = skins.filter(a => !a.isDefault);
        this.allFormations = formations.filter(a => !a.isDefault);
        this.allBoots = boots.filter(a => !a.isDefault);
      } catch (err) {
        console.log(err);
      }
    },
    async loadBot(id) {
      try {
        const service = new FakeUsersService();
        const bot = await service.findById({ id });
        this.bot = {
          ...emptyBot(),
          ...bot,
          avatars: bot.avatars || [],
          skins: bot.skins || [],
          formations: bot.formations || [],
          boots: bot.boots || [],
        };
      } catch (err) {
        console.log(err);
        window.notif({ mssg: 'ربات یافت نشد', isError: true });
        this.$router.push('/dashboard/fake');
      }
    },
    async save() {
      this.saving = true;
      try {
        const service = new FakeUsersService();
        const payload = this.buildPayload();

        if (this.botId) {
          payload.id = this.botId;
          await service.update({ body: payload });
          window.notif({ mssg: 'تغییرات اعمال شد', isError: false });
          await this.loadBot(this.botId);
        } else {
          const created = await service.create({ body: payload });
          this.botId = created._id;
          this.$router.replace({ path: '/dashboard/fakeBot', query: { id: created._id } });
          window.notif({ mssg: 'ربات ساخته شد', isError: false });
          await this.loadBot(this.botId);
        }
      } catch (err) {
        console.log(err);
        window.notif({ mssg: 'مشکلی پیش آمده', isError: true });
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
